import { localizeParam, matchParam } from '$lib/i18n-url';

const localizedParam = localizeParam(1, 'l_relatives', {
	en: 'for-relatives',
	de: 'fuer-angehoerige'
});

export const match = (param) => matchParam(param, localizedParam);
